export default {
  BOLETO: {
    mainText: "Em caso de dúvidas contate nossa central de atendimento pelo número: 0800 726 4000.",
    secondaryText: "Caso o pagamento já tenha sido realizado, por favor, desconsidere essa mensagem.",
    buttonLabel: "Ver faturas"
  },
  DEBITO: {
    mainText:
      "Para solicitar um novo débito ou geração de boleto bancário contate nossa central de atendimento pelo número: 0800 726 4000.",
    secondaryText: "",
    buttonLabel: "Ligar"
  }
} as const;
